export const CUSTOM_EVENTS = {
  SSO_SIGN_IN: 'SSO sign in',
  LOG_OUT: 'Log out',

  NEW_PROMPT_CLICK: 'New prompt btn clicked',
  HISTORY_ITEM_CLICKED: 'History item clicked',
  SHOW_DETAILED_STEPS: 'Show detailed steps',
  STARTED_TYPING_A_PROMPT: 'Started typing a prompt',
  PROMPT_SUBMITTED: 'Prompt submitted',
  EDIT_IMAGE: 'Edit image',
  DOWNLOAD_IMAGE: 'Download image',
  LOAD_MORE_IMAGES: 'Load more images',
  IMAGE_TO_PROMPT: 'Image to prompt',
  LANG_CHANGED: 'Language changed',
  THEME_CHANGED: 'Theme changed',
  IMAGE_UPSCALE: 'Image Upscale',
};
